var map = {
	"./amaze.png": 57982,
	"./angel.png": 17623,
	"./angry.png": 5665,
	"./applause.png": 7430,
	"./arrogant.png": 82874,
	"./astonished.png": 82824,
	"./awkward.png": 18692,
	"./bigcry.png": 77722,
	"./blessing.png": 52676,
	"./boo.png": 57850,
	"./bye.png": 92076,
	"./candle.png": 2247,
	"./cheer.png": 76835,
	"./comic.png": 15625,
	"./cool.png": 84998,
	"./crazy.png": 46823,
	"./cry.png": 8389,
	"./cute.png": 80798,
	"./daze.png": 96589,
	"./dignose.png": 47086,
	"./dizzy.png": 80217,
	"./dog.png": 27466,
	"./dontbicker.png": 38140,
	"./doubt.png": 4121,
	"./drinktea.png": 47313,
	"./dung.png": 70818,
	"./embrace.png": 46681,
	"./evil.png": 47328,
	"./facepalmcry.png": 73490,
	"./fallill.png": 6037,
	"./follow.png": 92739,
	"./frown.png": 67018,
	"./handshake.png": 80031,
	"./hard.png": 86864,
	"./heart.png": 64806,
	"./hehe.png": 4813,
	"./kiss.png": 47479,
	"./kneel.png": 84028,
	"./kneelcry.png": 49473,
	"./laughcry.png": 95799,
	"./lechery.png": 22982,
	"./letgo.png": 55697,
	"./like.png": 13013,
	"./majestic.png": 35625,
	"./ok.png": 64226,
	"./pathetic.png": 48629,
	"./praise.png": 82014,
	"./reversesmile.png": 49442,
	"./rose.png": 49435,
	"./shutup.png": 47008,
	"./shy.png": 72082,
	"./simper.png": 36262,
	"./slap.png": 53713,
	"./sleep.png": 87391,
	"./sleepy.png": 99293,
	"./smile.png": 7237,
	"./snap.png": 56494,
	"./split.png": 79964,
	"./stoptalking.png": 16686,
	"./struggle.png": 28132,
	"./sweat.png": 30464,
	"./teethlaugh.png": 83843,
	"./titter.png": 6647,
	"./vomit.png": 5431,
	"./wane.png": 96869,
	"./watermelon.png": 69032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17587;